import { Collection } from "@tblabs/truffle";
import { StepDataEditor } from "../../../../Components/StepDataEditor";
import { Step } from "../../../../Steps/Step/Step";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { Entry } from "./Entry";



export class GenericEntryEditBox extends Entry<Step<any>>
{
    constructor(step: Step<any>, steps: Collection<Step<any>>)
    {
        super(step, steps, [new StepDataEditor(step, false)]);

        this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
    }
}
